export default __webpack_public_path__ + "static/media/8.43a6e7d8.gif";